import { Fragment } from 'react';

import { DescriptionSection } from './DescriptionSection';
import { EnvironmentsSection } from './EnvironmentsSection';
import { ExcludingSection } from './ExcludingSection';
import { IdSection } from './IdSection';
import { ServeSection } from './ServeSection';
import { StateSection } from './StateSection';
import { ToSection } from './ToSection';
import type { Rule } from './types';

export const FlagUpdatesRuleDetails = ({
  oldRule,
  newRule,
}: {
  oldRule?: Rule;
  newRule?: Rule;
}) => {
  return (
    <Fragment>
      <IdSection oldRule={oldRule} newRule={newRule} />
      <DescriptionSection oldRule={oldRule} newRule={newRule} />
      <StateSection oldRule={oldRule} newRule={newRule} />
      <ServeSection oldRule={oldRule} newRule={newRule} />
      <EnvironmentsSection oldRule={oldRule} newRule={newRule} />
      <ToSection oldRule={oldRule} newRule={newRule} />
      <ExcludingSection oldRule={oldRule} newRule={newRule} />
      {/* TODO: sticky assignments and other options */}
    </Fragment>
  );
};
